import PropTypes from 'prop-types';
import { useMemo, useRef } from 'react';
import useDataLayer, { useResultsAvailableEvent } from '@/hooks/useDataLayer';
import useDestination from '@/hooks/useDestination';
import { getSearchDetails } from '@/utils/getDataLayerVariables';
import useGetPackagesCheapestOffer from '../../hooks/useGetPackagesCheapestOffer';

import { useDestination as v2UseDestination } from '@/v2/contexts/destination';

const DataLayer = ({ pageType }) => {
  const d = useDestination();
  const dV2 = v2UseDestination();

  const destination = d || dV2;
  const { searchQuery, packagesWithCheapestOffer, availability } =
    useGetPackagesCheapestOffer();

  const withoutSearchEvent = useMemo(
    () => ({
      destinationName: destination.title,
      event: 'pageView',
      pageType,
    }),
    [destination, pageType],
  );
  useDataLayer(withoutSearchEvent);

  const destinationRef = useRef();
  destinationRef.current = destination;

  const withSearchEvent = useMemo(() => {
    if (!searchQuery) {
      return null;
    }

    return {
      ...getSearchDetails(searchQuery),
      destinationName: destinationRef.current.title,
      event: 'pageView',
      pageType: `${pageType} With Search`,
    };
  }, [pageType, searchQuery]);
  useDataLayer(withSearchEvent);

  const extra = useMemo(
    () => ({
      destinationName: destination.title,
      pageType: `${pageType} With Search`,
      availability,
    }),
    [availability, destination, pageType],
  );

  useResultsAvailableEvent(
    searchQuery,
    pageType === 'Destination Page' || pageType === 'Theme Page'
      ? packagesWithCheapestOffer
      : null,
    extra,
  );

  return null;
};

DataLayer.propTypes = {
  pageType: PropTypes.oneOf([
    'Destination Page',
    'Destination Map View',
    'Theme Page',
    'Theme Map View',
  ]).isRequired,
};

export default DataLayer;
